import React from 'react';
import {Route} from 'react-router-dom';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';
import BeautyTechVirtualEvent from './../home/async';

export default [
  <Route
    key="/business/beauty-tech-forum-master-class"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/',
          },
          {
            position: 2,
            name: 'Business',
            item: '/business',
          },
          {
            position: 3,
            name: 'Master Class',
            item: '/business/beauty-tech-forum-master-class',
          },
        ]}
      />
    }
  >
    <Route
      path="business/beauty-tech-forum-master-class/:courseKey?"
      element={<BeautyTechVirtualEvent />}
    />
  </Route>,
];
